import React, { useState, Children } from 'react';
import { X } from 'lucide-react';
const privacyContent = `
Last updated: April 2026

Your privacy is important to us. This Privacy Policy explains how The 4-Hour Reset ("we," "us," or "our") collects, uses, and protects your information when you purchase and use our digital products.

Information We Collect
When you make a purchase, we collect your name, email address, and payment information. Payment processing is handled by secure third-party providers — we do not store your credit card details.

How We Use Your Information
We use your information solely to deliver your purchased digital products, send order confirmations, and provide customer support related to your purchase. We do not sell, rent, or share your personal information with third parties for marketing purposes.

Cookies
Our website may use cookies to improve your browsing experience. You can disable cookies in your browser settings at any time.

Data Security
We implement industry-standard security measures to protect your personal information. However, no method of electronic transmission or storage is 100% secure.

Children's Privacy
Our products are intended for adult parents and caregivers. We do not knowingly collect information from children under 13.

Changes to This Policy
We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.
`.trim();
const termsContent = `
Last updated: April 2026

By purchasing and accessing The 4-Hour Reset digital products, you agree to the following Terms of Service.

Digital Products
All products are delivered digitally via email immediately after purchase. You will receive access to downloadable materials including guides, cheat sheets, and video tutorials as described on the sales page.

Intellectual Property
All content included in The 4-Hour Reset bundle is protected by copyright. You may not reproduce, distribute, resell, or share any materials without written permission.

Medical Disclaimer
The 4-Hour Reset is an educational resource based on infant sleep science. It is not a substitute for professional medical advice. Always consult your pediatrician before making changes to your baby's sleep routine, especially if your child has medical conditions such as reflux or breathing difficulties.

Refund Policy
Due to the digital nature of our products, all sales are final. If you experience technical issues accessing your materials, please reach out and we will resolve the issue promptly.

Limitation of Liability
The 4-Hour Reset and its creators are not liable for any outcomes resulting from the use of our materials. Results may vary from family to family.

Governing Law
These terms are governed by applicable local laws. Any disputes will be resolved through good-faith communication.
`.trim();
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal border-t border-white/10 py-8 px-6" data-id="element-20">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-21">
          <p className="text-white/40 font-sans text-sm" data-id="element-22">
            © {new Date().getFullYear()} The 4-Hour Reset. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-23">
            <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-white/80 font-sans text-sm transition-colors" data-id="element-24">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-white/80 font-sans text-sm transition-colors" data-id="element-25">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setActiveModal(null)} data-id="element-26">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-27">
            <div className="flex items-center justify-between p-6 border-b border-sage/10" data-id="element-28">
              <h3 className="text-2xl font-serif text-charcoal" data-id="element-29">
                {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="text-charcoal/40 hover:text-charcoal transition-colors" aria-label="Close" data-id="element-30">
                <X className="w-6 h-6" data-id="element-31" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto" data-id="element-32">
              <div className="font-sans text-charcoal/80 leading-relaxed whitespace-pre-line text-sm" data-id="element-33">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </div>
          </div>
        </div>}
    </>;
}